
<main  class="container position-relative p-2">

    <!--? محتوای اصلی صفحه  -->

    <!-- border border-2 border-success -->

    <div class="row gx-0 gy-0">

        <!--? تبلیغات -->

        <div #point_1 class="central container ads_box"></div>

        <!--? آگهی های پیشنهادی -->

        <!-- <div class="my-2 border_bottom border border-2 border-primary"> </div> -->

        <!--? فیلتر آگهی ها -->

        <div class="sticky-category col-md-3 col-12 p-md-2 p-0">

            <!-- تعداد آگهی ها -->

            <div *ngIf="lst_Ads.length > 0" class="ads-count px-1 pt-1">

                <p class="mb-0"> نمایش {{ lst_Ads.length | faNum }} از {{ lst_Ads[0].iTotal | faNum }} آگهی </p>

            </div>

            <!-- جستجو در محتوای آگهی -->

            <div class="my-2 px-1">

                <div class="position-relative w-100">

                    <div class="form-group has-icon">
    
                        <span class="form-control-icon">
    
                            <mat-icon class="mat-18" aria-hidden="false">manage_search</mat-icon>
    
                        </span>
    
                        <input id="customInp" class="form-control" placeholder="جستجو کنید...">
    
                    </div>

                </div>

            </div>

            <!-- امکانات -->

            <article [formGroup]="mdl_Search" class="mt-1">

                <div class="accordion" id="accordionExample">

                    <!-- نوع آگهی -->

                    <div class="accordion-item">

                        <h2 class="accordion-header" id="headingOne">

                            <button class="accordion-button fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">

                                نوع آگهی

                                <div class="ads-options mx-2" *ngIf="hasSelected('tiType')">

                                    <span (click)="remove_Filter('tiType')"> حذف فیلتر </span>
    
                                </div>

                            </button>

                        </h2>

                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">

                            <div class="accordion-body py-2 px-2">

                                <ng-container *ngFor="let item of lst_Type">

                                    <div class="form-check form-switch px-1 py-2 m-0 d-flex align-items-center justify-content-between">
                                
                                        <label class="form-check-label pointer text-muted" for="tiType_all"> {{ item.strComment }} </label>
    
                                        <input class="form-check-input m-0" 
    
                                            (change)="mdl_Search.get('tiType')?.setValue(item.tiType);getAll_Ads(16)"
                                        
                                            [checked]="mdl_Search.get('tiType')?.value == item.tiType"
    
                                            type="checkbox" id="tiType_all">
                                    
                                    </div>

                                </ng-container>

                                <!-- همه -->

                                <div *ngIf="false" class="form-check form-switch px-1 py-2 m-0 d-flex align-items-center justify-content-between">
                                
                                    <label class="form-check-label pointer text-muted" for="tiType_all"> همه </label>

                                    <input class="form-check-input m-0" 

                                        (change)="mdl_Search.get('tiType')?.setValue('-1');getAll_Ads(16)"
                                    
                                        [checked]="mdl_Search.get('tiType')?.value == -1"

                                        type="checkbox" id="tiType_all">
                                
                                </div>

                                <!-- آماده به کار -->
                                
                                <div *ngIf="false" class="form-check form-switch px-1 py-2 m-0 d-flex align-items-center justify-content-between">
                                
                                    <label class="form-check-label pointer text-muted" for="tiType_Ready"> آماده به کار </label>

                                    <input class="form-check-input m-0" 

                                        [checked]="mdl_Search.get('tiType')?.value == 0"

                                        (change)="mdl_Search.get('tiType')?.setValue('0');getAll_Ads(17)"
                                    
                                        type="checkbox" id="tiType_Ready">
                                
                                </div>

                                <!-- نیازمند -->

                                <div *ngIf="false" class="form-check form-switch px-1 py-2 m-0 d-flex align-items-center justify-content-between">
                                
                                    <label class="form-check-label pointer text-muted" for="tiType_NeedToWork"> نیازمند </label>

                                    <input class="form-check-input m-0" 

                                        [checked]="mdl_Search.get('tiType')?.value == 1"

                                        (change)="mdl_Search.get('tiType')?.setValue('1');getAll_Ads(18)"
                                    
                                        type="checkbox" id="tiType_NeedToWork">
                                
                                </div>

                            </div>

                        </div>

                    </div>

                    <!-- شهر -->

                    <div class="accordion-item">

                        <h2 class="accordion-header" id="headingTwo">

                            <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">

                                شهر

                                <div class="ads-options mx-2" *ngIf="hasSelected('strCity')">

                                    <span (click)="remove_Filter('strCity')"> حذف فیلتر </span>
    
                                </div>

                            </button>

                        </h2>

                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">

                            <div class="accordion-body py-2 px-2">

                                <custom-filter *ngIf="showFilter && lst_City.length > 0"

                                    [strValue]="returnStrValue('strCity', mdl_Search.get('strCity')?.value,lst_City,'strCityName')"
                            
                                    [strComment]="'strCityName'"
                            
                                    [stylesArray]="['padding-top: 10px','text-align: start']"
                            
                                    [str_Placeholder]="' جستجو کنید...'"
                            
                                    [lst_Main]="lst_City" 
                            
                                    [lst_SearchKey]="['strCityName']"
                            
                                    [isDisabled]="mdl_Search.disabled || isCity ? true : false"
                                    
                                    (hideOptions)="mdl_Search.get('strCity')?.setValue($event?.strCity ? $event.strCity : '');getAll_Ads(6)">
                    
                                </custom-filter>

                            </div>

                        </div>

                    </div>

                    <!-- نوع خودرو -->

                    <div class="accordion-item">

                        <h2 class="accordion-header" id="headingThree">

                            <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">

                                نوع خودرو

                                <div class="ads-options mx-2" *ngIf="hasSelected('tiMobileType')">

                                    <span (click)="remove_Filter('tiMobileType')"> حذف فیلتر </span>
    
                                </div>

                            </button>

                        </h2>

                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">

                            <div class="accordion-body py-2 px-2">

                                <custom-filter *ngIf="showFilter && lst_MobileType.length > 0"

                                    [strValue]="returnStrValue('strComment', mdl_Search.get('tiMobileType')?.value,lst_MobileType,'strComment')"
                            
                                    [strComment]="'strComment'"
                            
                                    [stylesArray]="['padding-top: 10px','text-align: start']"
                            
                                    [str_Placeholder]="' جستجو کنید...'"
                            
                                    [lst_Main]="lst_MobileType" 
                            
                                    [lst_SearchKey]="['strComment']"
                            
                                    [isDisabled]="mdl_Search.disabled || isCity ? true : false"
                                    
                                    (hideOptions)="mdl_Search.get('tiMobileType')?.setValue($event?.tiMobileType ? $event.tiMobileType : '');getAll_Ads(7)">
                    
                                </custom-filter>

                                <!-- <div class="form-group has-icon w-100 p-2">
                
                                    <select class="form-select p-2" formControlName="tiMobileType">
                        
                                        <option class="text-center" [value]="-1"> همه خودروها </option>
            
                                        <option class="text-center" *ngFor="let item of lst_MobileType" [value]="item.tiMobileType"> 

                                            {{ item.strComment }}
                                                                                    
                                        </option>
                        
                                    </select>                        
                        
                                </div> -->

                            </div>

                        </div>

                    </div>

                    <!-- نام خودرو -->

                    <div class="accordion-item">

                        <h2 class="accordion-header" id="headingFour">

                            <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">

                                نام خودرو

                                <div class="ads-options mx-2" *ngIf="hasSelected('tiGPSType')">

                                    <span (click)="remove_Filter('tiGPSType')"> حذف فیلتر </span>
    
                                </div>

                            </button>

                        </h2>

                        <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">

                            <div class="accordion-body py-2 px-2">

                                <custom-filter *ngIf="showFilter && lst_GpsType.length > 0"

                                    [strValue]="returnStrValue('strComment', mdl_Search.get('tiGPSType')?.value,lst_GpsType,'strComment')"
                            
                                    [strComment]="'strComment'"
                            
                                    [stylesArray]="['padding-top: 10px','text-align: start']"
                            
                                    [str_Placeholder]="' جستجو کنید...'"
                            
                                    [lst_Main]="lst_GpsType" 
                            
                                    [lst_SearchKey]="['strComment']"
                            
                                    [isDisabled]="mdl_Search.disabled || isCity ? true : false"
                                    
                                    (hideOptions)="mdl_Search.get('tiGPSType')?.setValue($event?.tiGPSType ? $event.tiGPSType : '');getAll_Ads(8)">
                    
                                </custom-filter>
                                                
                                <!-- <select class="form-select p-2" formControlName="tiGPSType">
                        
                                    <option class="text-center" [value]="-1"> همه خودروها </option>
        
                                    <option class="text-center" *ngFor="let item of lst_GpsType" [value]="item.tiGPSType"> 

                                        {{ item.strComment }}
                                                                                
                                    </option>
                    
                                </select>     -->

                            </div>

                        </div>


                    </div>

                    <!-- نوع قرارداد -->

                    <div class="accordion-item">

                        <h2 class="accordion-header" id="headingFive">

                            <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">

                                نوع قرارداد

                                <div class="ads-options mx-2" *ngIf="hasSelected('bHourly') || hasSelected('bKeyInHand') || hasSelected('bMonthly')">

                                    <span (click)="remove_Filter_2()"> حذف فیلتر </span>
    
                                </div>

                            </button>

                        </h2>

                        <div id="collapseFive" class="accordion-collapse collapse " aria-labelledby="headingFive" data-bs-parent="#accordionExample">

                            <div class="accordion-body py-2 px-2">

                                <!-- ساعتی -->

                                <div class="form-check form-switch px-1 py-2 m-0 d-flex align-items-center justify-content-between">
                                
                                    <label class="form-check-label pointer text-muted" for="bHourly"> ساعتی </label>

                                    <input class="form-check-input m-0" type="checkbox" id="bHourly" formControlName="bHourly" (change)="getAll_Ads(9)">
                                
                                </div>

                                <!-- ماهیانه -->
                                
                                <div class="form-check form-switch px-1 py-2 m-0 d-flex align-items-center justify-content-between">
                                
                                    <label class="form-check-label pointer text-muted" for="bMonthly"> ماهیانه </label>

                                    <input class="form-check-input m-0" type="checkbox" id="bMonthly" formControlName="bMonthly" (change)="getAll_Ads(12)">
                                
                                </div>

                                <!-- کلید در اختیار -->

                                <div class="form-check form-switch px-1 py-2 m-0 d-flex align-items-center justify-content-between">
                                
                                    <label class="form-check-label pointer text-muted" for="bKeyInHand"> کلید در اختیار </label>

                                    <input class="form-check-input m-0" type="checkbox" id="bKeyInHand" formControlName="bKeyInHand" (change)="getAll_Ads(13)">
                                
                                </div>


                            </div>

                        </div>

                    </div>

                    <!-- تاریخ -->

                    <div class="accordion-item">

                        <h2 class="accordion-header" id="headingSeven">

                            <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">

                                تاریخ

                                <div class="ads-options mx-2" *ngIf="hasSelected('strSDate') || hasSelected('strEDate')">

                                    <span (click)="remove_Filter('strSDate');remove_Filter('strEDate')"> حذف فیلتر </span>
    
                                </div>


                            </button>

                        </h2>

                        <div id="collapseSeven" class="accordion-collapse collapse " aria-labelledby="headingSeven" data-bs-parent="#accordionExample">

                            <div class="accordion-body py-2 px-2">

                                <!-- از تاریخ -->

                                <div class="w-100">

                                    <div class="position-relative p-2"> 
                
                                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" (dateOnSelect)="getAll_Ads(14)"
                
                                            [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">
                            
                                            <input formControlName="strSDate" class="form-control p-2" placeholder="از تاریخ"/>
                            
                                        </ng-persian-datepicker>
                            
                                    </div>

                                </div>

                                <!-- تا تاریخ -->

                                <div class="w-100">

                                    <div class="position-relative p-2"> 
                
                                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" (dateOnSelect)="getAll_Ads(15)"
                
                                            [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">
                            
                                            <input formControlName="strEDate" class="form-control p-2" placeholder="تا تاریخ" />
                            
                                        </ng-persian-datepicker>
                            
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </article>

        </div>

        <!--? لیست آگهی های ثبت شده -->

        <div class="col-md-9 col-12 p-md-2 p-0">

            <div #point_2 class="row gy-0">

                <ng-container *ngIf="lst_Ads.length > 0">

                    <!-- آگهی ها -->

                    <div class="col-lg-6 mb-2" *ngFor="let item of lst_Ads;let i = index">

                        <ng-container *ngIf="i == 1">

                            <span #firstResult></span>

                        </ng-container>

                        <ng-container *ngIf="i == 10">

                            <span #upButton></span>

                        </ng-container>

                        <div class="ads_card pointer" (click)="showAds(item)" [ngClass]="item.bVIP ? 'vip-ads' : ''">

                            <!-- اطلاعات آگهی -->

                            <div class="w-100 h-100 p-2">

                                <!-- عنوان -->

                                <h1 class="text-muted fw-bold mb-1"> {{ subString_Title(item.strTitle,31) }} </h1>

                                <!-- شهر -->

                                <h2 class="text-muted mb-0"> {{ item.strPublishTime }} در {{ item.strCityName }} </h2>

                                <!-- نوع خودرو -->

                                <h3 class="text-muted mb-1"> {{ item.strMobileType_strComment }} - {{ item.strGPSType_strComment }} </h3>

                                <div class="ads-options">

                                    <span *ngIf="item.strType">{{ item.strType }}</span>

                                    <span *ngIf="item.bKeyInHand">کلید در اختیار</span>

                                    <span *ngIf="item.bHourly">ساعتی</span>

                                    <span *ngIf="item.bMonthly">ماهیانه</span>
                                    
                                </div>

                            </div>

                            <!-- تصویر آگهی -->

                            <div class="img_box position-reltive">

                                <img src="{{ item.strImage ? 'data:image/jpeg;base64,' + item.strImage : '../../../assets/imgs/preview__thumbnail.png' }}" [alt]="item.strTitle" [title]="item.strTitle">

                                <div class="ads-visited position-absolute">

                                    <span class="text-white"> {{ item.iView | faNum }} </span>

                                    <mat-icon class="me-1 text-white">visibility</mat-icon>

                                </div>

                            </div>

                        </div>

                    </div>

                    <!-- اسکرول لودینگ -->

                    <div Infinite-Scroll [ngClass]="(bScrollLoading && !bDataEnded) ? 'infinite-scroll w-100' : '' ">

                        <ng-container *ngIf="bScrollLoading && !bDataEnded">

                            <div class="loader"></div>

                        </ng-container>

                    </div>

                    <!--  -->

                    <div *ngIf="!bDataEnded" class="p-5"></div>

                    <!--  -->

                    <div *ngIf="bDataEnded" class="row gx-2 justify-content-center align-items-center p-3">

                        <div class="col-5 ps-1">

                            <div class="border"></div>

                        </div>

                        <div class="col-1 d-flex justify-content-center align-items-center">

                            <ng-container *ngIf="mdl_Search.get('tiType')?.value as tiType">

                                <mat-icon class="texr-secondary pointer" title="رفتن به بالا" (click)="gotoTop()">

                                    category

                                </mat-icon>

                            </ng-container>

                        </div>

                        <div class="col-5 pe-1">

                            <div class="border"></div>

                        </div>

                    </div>


                </ng-container>

                <!-- نتیجه ایی یافت نشد -->

                <div *ngIf="!bResults" class="col-12 d-flex flex-column justify-content-center align-items-center mb-2 p-5">

                    <img width="170px" height="170px" src="../../../assets/imgs/no-results.png" alt="no results...">

                    <h2 class="mt-2"> متاسفانه نتیجه ایی یافت نشد. </h2>

                </div>

            </div>

        </div>

    </div>

    <!--? دکمه رفتن به بالا -->

    <div class="scrollTop-Container pointer" (click)="gotoTop()" *ngIf="bUpButton">

        <div class="d-flex justify-content-center align-items-center">

            <mat-icon style="color: #011637;font-weight: 400;">

                arrow_upward

            </mat-icon>

        </div>

    </div>

</main>